"use client";

import { useState } from "react";
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';
import CustomSelect from "./CustomSelect";

const ContactForm = () => {
  const [selectedOption, setSelectedOption] = useState('استفسار');
  const options = ['استفسار', 'مقترح', 'شكوى'];

  const sendEmail = (e) => { 
    e.preventDefault(); 

    emailjs.sendForm(process.env.REACT_APP_EMAILJS_INFO_DAREENA_SERVICE_ID, process.env.REACT_APP_EMAILJS_INFO_DAREENA_TEMPLATE_ID_CONTACT, e.target, process.env.REACT_APP_EMAILJS_INFO_DAREENA_PUBLIC_ID)
    .then((response) => {
      Swal.fire({
        icon: "success",
        // title: "Message sent successfully!",
        title: "تم إرسال الرسالة بنجاح!",
        draggable: true
      });
    })
    .catch((err) => {
      Swal.fire({
        icon: "error",
        // title: 'Failed to send message. Please try again later.',
        title: 'فشل في إرسال الرسالة. يرجى المحاولة مرة أخرى لاحقا.',
        draggable: true
      });
    });
  }

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile_number: '',
    purpose_of_communication: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <form onSubmit={sendEmail} className="w-full max-w-screen-md mx-auto shadow-[0_4px_20px_rgba(0,0,0,0.2)] px-4 py-8 md:px-10 md:py-16 -shadow-lg rounded">
        
        <img src="/images/contact/contact-form-svgrepo-com.svg" alt="contact busines card" className="w-40 mx-auto mb-8 md:pb-4"/>
        
        <div className="grid gap-y-4">
          {/* name */}
          <div className="grid gap-y-2">
            <label htmlFor="name">الاسم الكريم</label>
            <input type="text" name="name" id="name" placeholder="مثال: صلاح محمد" className="border-2 rounded-full py-1 px-4 block w-full"  required="required" aria-required="true" value={formData.name} onChange={handleChange}/>
          </div>

          <div className="md:flex md:gap-4">
            {/* email */}
            <div className="grid gap-y-2">
              <label htmlFor="email">البريد الإلكتروني</label>
              <input type="email" name="email" id="email" placeholder="مثال: example@gmail.com" className="border-2 rounded-full py-1 px-4 block w-full" required="required" aria-required="true" value={formData.email} onChange={handleChange}/>
            </div>
            
            {/* phone number */}
            <div className="grid gap-y-2">
              <label htmlFor="mobile_number">رقم الجوال</label>
              <input type="text" name="mobile_number" id="mobile_number" className='border-2 rounded-full py-1 px-4 block w-full' title="Only numbers and phone characters (#, -, *, etc) are accepted." placeholder="مثال:  12345656 966+ " required="required" aria-required="true" value={formData.mobile_number} onChange={handleChange}/>
            </div>
          </div>

          {/* the purpose of communication */}
          <CustomSelect 
            options={options} 
            value={selectedOption}
            onChange={setSelectedOption}
            name="purpose_of_communication"
            id="purpose_of_communication"
          />

          {/* message */}
          <div className="grid gap-y-2">
            <label htmlFor="message">الرسالة</label>
            <textarea name="message" id="message" placeholder="اكتب ما تشاء.." className="block w-full border-2 rounded-md py-2 px-4" rows="5" value={formData.message} onChange={handleChange}></textarea>
          </div>
        </div>
        
        <button
          type="submit"
          className="bg-primary px-4 py-2 text-white rounded-xl mt-2 md:mt-4 flex flex-row-reverse items-center gap-x-2"
        ><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m5 12l6-6m-6 6l6 6m-6-6h14" />
      </svg></span> <span>ارسال</span></button>
      </form>
    </>
  );
};

export default ContactForm;
